import axios from 'axios';

import { manufacturerAPI } from './requests';

import { ROLES } from 'constants/roles';

import { store } from 'App';
import config from 'config';
import { USER_LOG_OUT_SUCCESS } from 'store/actionTypes';
import NotificationManager from 'dom-managers/notification';

const instance = axios.create({
  baseURL: config.baseURL
});

instance.interceptors.request.use(cfg => {
  getAuthorizationHeader(cfg);
  getManufacturerCode(cfg);
  return cfg;
});

instance.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (error.response) {
      if (error.response.status === 401 || error.response.status === 403) store.dispatch({ type: USER_LOG_OUT_SUCCESS });

      if (
        error.response.status === 500 &&
        error.response.data &&
        typeof error.response.data === 'object' &&
        (error.response.data.message === '403 Forbidden' || error.response.data.status === 'FORBIDDEN') 
      ) {
        store.dispatch({ type: USER_LOG_OUT_SUCCESS });
      }

      if (error.response.status > 299 && error.response.status < 400) {
        return Promise.resolve(error.response);
      } else {
        let message = '';
        if (typeof error.response === 'string') {
          message = error.response;
        } else if (typeof error.response.data === 'string') {
          message = error.response.data;
        } else {
          message = error.response.data.error_description || error.response.data.message;
        }

        if (!message) {
          let reader = new FileReader();
          reader.onloadend = (event) => {
            try {
              NotificationManager.error(error.response.status, JSON.parse(event.target.result).message);
            } catch (e) {
              NotificationManager.error(error.response.status, event.target.result);
            }
          };
          reader.readAsText(error.response.data);
        } else {
          NotificationManager.error(error.response.status, message);
        }

        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

function isCommunityHubOAuthUrl(url = '') {
  return url.includes('/services/oauth2/');
}

function getAuthorizationHeader(cfg) {
  if (cfg.headers && cfg.headers.Authorization) return;
  if (isCommunityHubOAuthUrl(cfg.url)) return;

  if (!cfg.url.includes('/user/oauth/token') && !cfg.url.includes('/user/userInfo')) {
    const state = store.getState();
    const token = state.user.token;
    cfg.headers.Authorization = `Bearer ${token}`;
  }
}

function getManufacturerCode(cfg) {
  if (isCommunityHubOAuthUrl(cfg.url)) return;
  if (
    !cfg.url.includes('/user/oauth/token') &&
    !cfg.url.includes('/user/userInfo') &&
    !cfg.url.includes('/manufacturer/api/v1/manufacturer?role=') &&
    !cfg.url.includes('/revoke') &&
    !cfg.url.includes('/component_types') &&
    !cfg.url.includes('/manufacturer/api/v1/manufacturer/changeStatus')
  ) {
    const state = store.getState();

    if (
      cfg.url.includes('/checklist') ||
      cfg.url.includes('/brand') ||
      cfg.url.includes('/mic/number') ||
      cfg.url.includes('/api/') ||
      cfg.url.includes('manufacturer/api/v1/cert/') ||
      cfg.url.includes(manufacturerAPI.capacityTagStatus) ||
      state.user.roles[0] === ROLES.INTERNAL.serverName ||
      state.user.roles[0] === ROLES.INSPECTION.serverName
    ) {
      let code = undefined;

      if (state.user.selectedManufacturer) {
        code = state.user.selectedManufacturer.code;
      } else if (state.user.manufacturer) {
        code = state.user.manufacturer.code;
      } else {
        code = state.user.accountCode;
      }
      if(code) {
        const separator = cfg.url.includes('?') ? '&' : '?';
        cfg.url = `${cfg.url}${separator}mnfCode=${code}`;
      }
    }
  }
}

export default instance;



// WEBPACK FOOTER //
// ./src/app/api/http.js